module.exports = __webpack_public_path__ + "/images/cover-cta-sophie-chupete.65747d6.jpg";